import _ from 'lodash'
import React, { PureComponent} from "react"
import PropTypes from "prop-types"
import { createDeepLinkPath, escapeDeepLinkPath } from "core/utils"
import { helpers } from "swagger-client"

const { opId } = helpers

export default class MqSidebar extends PureComponent {
  static propTypes = {
    toggleMobileNav: PropTypes.func.isRequired,
    specSelectors: PropTypes.object.isRequired
  }

  render() {
    let {
      toggleMobileNav,
      specSelectors
    } = this.props

    let taggedOps = specSelectors.taggedOperations();

    return (
      <aside className="main__sidebar">
        <nav className="global-nav global-nav--icon-menu">
          <div className="global-nav__content">
            <div className="global-nav__content-inner">
              <div className="global-nav-fill">
                <div className="global-nav__header">
                  <div className="global-nav__branding">
                    <div className="global-nav__logo">
                      <svg viewBox="-10 0 540 70" id="mQ-logo-white-large" className="ui-icon ui-icon--logo-md" aria-hidden="true">
                        <path id="mQWhiteLarge-bezier" stroke="none" fill="rgb(255, 255, 255)" d="M 273.6,2.18 L 277.4,2.18 277.4,46.33 273.6,46.33 273.6,2.18 Z M 273.6,2.18"/>
                        <path id="mQWhiteLarge-bezier2" stroke="none" fill="rgb(255, 255, 255)" d="M 239.01,22.81 L 209.24,22.81 209.24,2.18 205.44,2.18 205.44,46.34 209.24,46.34 209.24,26.61 239.01,26.61 239.01,46.34 242.81,46.34 242.81,2.18 239.01,2.18 239.01,22.81 Z M 239.01,22.81"/>
                        <path id="mQWhiteLarge-bezier3" stroke="none" fill="rgb(255, 255, 255)" d="M 344.93,42.54 L 344.55,42.54 314.91,2.18 308.77,2.18 308.77,46.34 312.57,46.34 312.57,5.98 312.99,5.98 342.62,46.34 348.73,46.34 348.73,2.18 344.93,2.18 344.93,42.54 Z M 344.93,42.54"/>
                        <rect id="mQWhiteLarge-rectangle" stroke="none" fill="rgb(255, 255, 255)" x="378.95" y="2.16" width="34.3" height="3.8"/>
                        <path id="mQWhiteLarge-bezier4" stroke="none" fill="rgb(255, 255, 255)" d="M 382.77,29.53 C 382.77,27.92 384.09,26.61 385.71,26.61 L 406.69,26.61 406.69,22.81 385.71,22.81 C 381.99,22.81 378.97,25.82 378.97,29.53 L 378.97,46.34 413.27,46.34 413.27,42.54 382.77,42.54 382.77,29.53 Z M 382.77,29.53"/>
                        <path id="mQWhiteLarge-bezier5" stroke="none" fill="rgb(255, 255, 255)" d="M 23.56,25.52 C 23.5,25.6 23.39,25.65 23.27,25.65 23.15,25.65 23.03,25.6 22.98,25.52 L 6.11,2.23 0,2.23 0,46.33 3.8,46.33 3.8,6.03 4.17,6.03 19.9,27.75 C 20.68,28.83 21.94,29.47 23.27,29.47 24.6,29.47 25.86,28.83 26.64,27.75 L 42.36,6.03 42.73,6.03 42.73,46.33 46.53,46.33 46.53,2.23 40.42,2.23 23.56,25.52 Z M 23.56,25.52"/>
                        <path id="mQWhiteLarge-bezier6" stroke="none" fill="rgb(255, 255, 255)" d="M 175.75,33.46 C 172.33,39.75 165.75,43.66 158.56,43.66 147.8,43.66 139.04,34.95 139.04,24.25 139.04,13.55 147.8,4.84 158.56,4.84 165.72,4.84 172.3,8.73 175.72,15 L 175.91,15.35 179.24,13.53 179.05,13.18 C 174.96,5.69 167.11,1.04 158.55,1.04 145.69,1.04 135.24,11.45 135.24,24.25 135.24,37.05 145.7,47.46 158.55,47.46 167.13,47.46 174.99,42.79 179.07,35.27 L 179.26,34.92 175.92,33.11 175.75,33.46 Z M 175.75,33.46"/>
                        <path id="mQWhiteLarge-bezier7" stroke="none" fill="rgb(255, 255, 255)" d="M 92.5,2.18 L 103.77,27.53 84.15,27.53 C 81.51,27.53 79.11,29.08 78.03,31.48 L 71.36,46.34 75.52,46.34 81.49,33.04 C 81.96,32 83,31.33 84.15,31.33 L 105.46,31.33 112.13,46.34 116.29,46.34 96.65,2.18 92.5,2.18 Z M 92.5,2.18"/>
                        <path id="mQWhiteLarge-bezier8" stroke="none" fill="rgb(255, 71, 19)" d="M 469.65,31.43 L 464.22,24.08 456.54,29.79 462.15,37.35 457.82,37.46 C 450.32,37.46 443.82,30.94 443.82,23.44 443.82,15.03 450.52,9.04 458.02,9.04 466.38,9.04 472.25,15.8 472.25,23.54 472.24,26.21 471.3,29.23 469.65,31.43 Z M 476.75,36.77 C 479.58,32.85 481.18,28.09 481.18,23.17 481.18,7.19 464.91,-5.07 448.07,2.09 443.07,4.21 439.06,8.22 436.94,13.22 429.78,30.07 442.03,46.33 458.02,46.33 L 484.79,46.33 484.79,36.76 476.75,36.76 476.75,36.77 Z M 476.75,36.77"/>
                        <path id="mQWhiteLarge-bezier9" stroke="none" fill="rgb(255, 255, 255)" d="M 496.38,3.08 L 492.82,3.08 492.82,2.18 500.9,2.18 500.9,3.08 497.34,3.08 497.34,13.22 496.38,13.22 496.38,3.08 Z M 496.38,3.08"/>
                        <path id="mQWhiteLarge-bezier10" stroke="none" fill="rgb(255, 255, 255)" d="M 514.41,2.18 L 510.33,7.98 506.13,2.18 505.21,2.18 505.21,13.22 506.13,13.22 506.13,3.69 509.88,8.95 510.68,8.95 514.41,3.68 514.41,13.22 515.34,13.22 515.34,2.18 514.41,2.18 Z M 514.41,2.18"/>
                      </svg>
                    </div>
                  </div>
                  <button type="button" className="global-nav__nav-toggle" onClick={toggleMobileNav}>
                    <div className="global-nav__nav-toggle-icon global-nav__navigation-icon">
                      <svg viewBox="0 0 25 25" id="close" width="100%" height="100%">
                        <path fill="currentColor" d="M 12,10.94 L 18.74,4.2 C 19.04,3.9 19.51,3.9 19.8,4.2 20.1,4.49 20.1,4.96 19.8,5.26 L 13.06,12 19.8,18.74 C 20.1,19.04 20.1,19.51 19.8,19.8 19.51,20.1 19.04,20.1 18.74,19.8 L 12,13.06 5.26,19.8 C 4.96,20.1 4.49,20.1 4.2,19.8 3.9,19.51 3.9,19.04 4.2,18.74 L 10.94,12 4.2,5.26 C 3.9,4.96 3.9,4.49 4.2,4.2 4.49,3.9 4.96,3.9 5.26,4.2 L 12,10.94 Z M 12,10.94"/>
                      </svg>
                    </div>
                    <span className="vh">Collapse Menu</span>
                  </button>
                </div>

                <ul className="global-nav__navigation">
                  {_.map(taggedOps.toJS(), (tagObj, tag) => {
                    const tagLink = ["operations-tag", createDeepLinkPath(tag)].join("-");
                    const operations = _.get(tagObj, 'operations', []);

                    return (
                      <li className="global-nav__navigation-item" key={tag}>
                        <a className="global-nav__navigation-link" href={`#${tagLink}`}>
                          <span className="global-nav__navigation-item-label">{tag}</span>
                        </a>

                        {operations &&
                          <ul className="global-nav__nested">
                            {operations.map( op => {
                              const path = op.path;
                              const method = op.method;
                              const operationId = _.get(op, 'operation.__originalOperationId') || _.get(op, 'operation.operationId') || opId(op.operation, path, method) || op.id;
                              const operationLink = escapeDeepLinkPath(["operations", tag, operationId].join("-"));

                              return (
                                <li className="global-nav__nested-item" key={`${tag}-${operationId}`}>
                                  <a className={`${!_.isEmpty(method) ? 'method-badge' + ' _method--' + method + '' : ''}`} href={`#${operationLink}`}>
                                    {method && <span className="method-badge__item">{method}</span>}
                                    <span>{_.get(op, 'operation.summary', '')}</span>
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        }
                      </li>
                    )
                  })}
                </ul>

              </div>
            </div>
          </div>
        </nav>

        <div className="global-nav__dimmer" />
      </aside>
    );
  }

}



// WEBPACK FOOTER //
// ./src/machineq/components/MqSidebar.jsx